import { cookieBanner, init as initWebPrivacyRuntime } from '@byted/web-privacy-sdk';
import { loadFbpScript, loadGAScript, loadTtqScript } from './loadScipts';
import { SellerPortalHostMap } from '@/constants';
const langMap = {
  'zh-CN': 'zh-Hans'
};
export const loadCookiebanner = (lang, region) => {
  var _a;

  const locale = (_a = langMap[lang]) !== null && _a !== void 0 ? _a : lang; // 确保先调用init方法。region会影响到数据上报机房，务必确保region值正确，枚举值为sg va us-ttp，大小写都可。

  initWebPrivacyRuntime({
    locale,
    region // support: sg, va, us-ttp. Case insensitive.

  }); // 启用cookie banner能力

  cookieBanner.loadCookieBanner({
    locale,
    onConsentGet: consent => {
      const isZH = new RegExp(SellerPortalHostMap.zh).test(location.origin);

      if (!isZH && consent.ga) {
        loadGAScript();
      }

      if (!isZH && consent.fbp) {
        loadFbpScript();
      }

      if (!isZH && consent.ttads) {
        loadTtqScript();
      }
    }
  });
};